import React, { FC, useState } from 'react';

//devextreme
import { Popup } from 'devextreme-react/popup';

import ModalFooter from 'components/appModalFooter';
import { isSuccess } from 'utils/responseStatus';

import { useDeleteTransportMutation } from 'bus/transport/transport';

type Props = {
  id: number | null;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const DeleteModal: FC<Props> = (props) => {
  const [deleteTransport, { isLoading }] = useDeleteTransportMutation();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: any) => {
    setLoading(true);
    e.preventDefault && e.preventDefault();
    deleteTransport({ id: props.id! }).then((resp: any) => {
      if (isSuccess(resp)) {
        props.changeVisible(false);
        props.refresh();
      }
      setLoading(false);
    });
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Подтвердите действие"
        width={400}
        height={160}
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">Вы действительно хотите удалить транспорт?</div>
            <ModalFooter
              useSubmitBehavior={false}
              handleSubmit={handleSubmit}
              hideModal={() => props.changeVisible(false)}
              textConfirm="Удалить"
              typeConfirm="danger"
              disabledSubmit={loading || isLoading}
            />
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default DeleteModal;
